import { AgGridReact } from "@jsq/ds/core";
import {
  typeValueFormatter,
  resolutionCellRenderer,
  RESOLUTION_FILTER_VALUES,
} from "../../CasesOverview/columnDefinitions";

export const getColumnDefinitions = (): AgGridReact.AgGridReactProps["columnDefs"] => [
  {
    field: "creationDate",
    headerName: "Date",
    filter: false,
    minWidth: 120,
  },
  {
    field: "assignee",
    headerName: "Modified by",
    filter: "agTextColumnFilter",
    filterParams: {
      filterOptions: ["contains"],
      maxNumConditions: 1,
    },
    minWidth: 150,
    flex: 1,
  },
  {
    field: "type",
    headerName: "Type",
    filter: false,
    sortable: false,
    valueFormatter: typeValueFormatter,
    minWidth: 150,
  },
  {
    field: "resolution",
    headerName: "Resolution",
    filter: "agSetColumnFilter",
    filterParams: {
      values: RESOLUTION_FILTER_VALUES,
    },
    cellRenderer: resolutionCellRenderer,
    minWidth: 130,
  },
  {
    field: "resolvedByName",
    headerName: "Resolved by",
    filter: false,
    sortable: false,
    minWidth: 150,
  },
];
